import SimpleCollectionList from "@/js/Shared/Collections/SimpleCollectionList";

export {DragItem as default};

/**
 * DragItem
 *
 * @author      rsommerfeld <roni.s.sommerfeld@altice.pt>
 * @copyright   Copyright (C) Sapo. All rights reserved.
 * @license     Private
 * @since       7.0.0
 */
class DragItem {
  /**
   * Event of drag eg: message,contact,folder...
   *
   * @type {String}
   */
  event;

  /**
   * Element HTML used in directive
   *
   * @type {HTMLElement}
   */
  element_event;

  /**
   * Initial value used in drag start
   *
   * @type {*}
   */
  initial_data;

  /**
   * Destination drag drop item
   *
   * @type {*}
   */
  drop_data;

  /**
   * Destination drop data
   *
   * @type {String}
   */
  drop_suffix;

  /**
   * Destination where drag was unleashed
   *  identifies events that are
   *  authorized to receive
   *
   * @type {Array}
   */
  drop_events;

  /**
   * Collection Itens in drag
   * @type {Object}
   */
  data = new SimpleCollectionList;
}